import { createContext } from 'react'

export interface IFlexGridWrapperActionsContext {
  saveAsDefault: () => Promise<void>
  resetToDefault: () => Promise<void>
  exportSettings: () => Promise<void>
  isActionInProgress: boolean
}

export const FlexGridWrapperActionsContext = createContext<IFlexGridWrapperActionsContext>({
  saveAsDefault: async () => undefined,
  resetToDefault: async () => undefined,
  exportSettings: async () => undefined,
  isActionInProgress: false,
})
